import { render, staticRenderFns } from "./DataUsage.vue?vue&type=template&id=d800b9bc&"
import script from "./DataUsage.vue?vue&type=script&lang=ts&"
export * from "./DataUsage.vue?vue&type=script&lang=ts&"
import style0 from "./DataUsage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports